import { normalizeUserSafeApiError } from "@cmts/api/apiErrorNormalizer.js";
import { ApiErrorPanel } from "./errors/ApiErrorPanel.js";

export type CmtsApiErrorPanelProps = {
  readonly error?: unknown | undefined;
  readonly title?: string | undefined;
  readonly message?: string | undefined;
  readonly correlationId?: string | undefined;
  readonly retryable?: boolean | undefined;
  readonly onRetry?: (() => void) | undefined;
  readonly className?:string;
};

export function CmtsApiErrorPanel(props: CmtsApiErrorPanelProps) {
  const input = props.error ?? props.message;
  if (input === undefined || input === null) return null;
  const normalized = normalizeUserSafeApiError(input);
  const safeMessage = props.message ?? normalized.userMessage;
  return (
    <ApiErrorPanel
      error={{
        ...normalized,
        message: safeMessage,
        correlationId: props.correlationId ?? normalized.correlationId,
        retryable: props.retryable ?? normalized.retryable,
      }}
      title={props.title ?? "CMTS runtime issue"}
      onRetry={props.onRetry}
    />
  );
}
